import { writable } from "svelte/store";

export const isDemo = writable(false);
